import en from './en.json';
import {notifyException} from 'utilities/analytics/bugsnag';

const i18nArgs = {
  id: 'ValidateStoreName',
  fallback: en,
  async translations(locale) {
    try {
      const dictionary = await import(
        /* webpackChunkName: "ValidateStoreName-i18n-[request]" */ `./${locale}.json`
      );
      return dictionary;
    } catch (error) {
      notifyException({
        errorName: 'I18n:ValidateStoreName',
        error,
      });
    }
    return en;
  },
};

export default i18nArgs;
